import { FunctionComponent } from "react";
import NAV from "../components/NAV";

const Lesson36: FunctionComponent = () => {
  return (
    <div className="relative [background:linear-gradient(111.77deg,_rgba(0,_0,_0,_0),_#363636_78.54%),_#0d0d0d] w-full overflow-hidden flex flex-col items-center justify-center pt-[2.69rem] px-[2.69rem] pb-[7.63rem] box-border gap-[6.88rem] text-left text-[1.56rem] text-darkgray font-nunito">
      <NAV dimensionCode="/nav@2x.png" navIconFlexShrink="unset" />
      <div className="self-stretch flex flex-row items-center justify-between">
      <a className="cursor-pointer text-darkgray no-underline" href={"/lesson35"}>
        <div className="flex-1 rounded-32xl bg-gainsboro-200 box-border h-[3.5rem] flex flex-col items-center justify-center py-[0.69rem] px-[3rem] max-w-[12.5rem] border-[1px] border-solid border-gray-300">
          <b className="relative inline-block w-[3.75rem] h-[2.06rem] shrink-0">
            Back
          </b>
        </div>
        </a>
        <div className="self-stretch flex-1 flex flex-col items-center justify-center text-center text-[2.81rem] text-white">
          <b className="self-stretch relative leading-[100%]">Olive Oils</b>
        </div>
        <a className="cursor-pointer text-darkgray no-underline" href={"/lesson37"}>
        <div className="flex-1 rounded-32xl bg-gainsboro-200 box-border h-[3.5rem] flex flex-col items-center justify-center py-[0.69rem] px-[3rem] max-w-[12.5rem] border-[1px] border-solid border-gray-300">
          <b className="relative inline-block w-[3.75rem] h-[2.06rem] shrink-0">
            Next
          </b>
        </div>
        </a>
      </div>
      <div className="w-full flex flex-col items-center justify-center gap-[9.63rem] max-w-[125rem] text-justify text-[1.88rem] text-white font-dm-sans">
        <div className="self-stretch relative tracking-[0.02em] leading-[2rem]">
          <p className="m-0">
            <b>
              <span>
                What Is Extra Virgin Olive Oil, and Why Is It Healthy?
              </span>
            </b>
          </p>
          <p className="m-0 text-gainsboro-100">
            <span>
              <b>&nbsp;</b>
            </span>
          </p>
          <p className="m-0 text-[1.56rem]">
            <span>
              <span>
                Known for its rich flavor, versatility, and health benefits,
                extra virgin olive oil is an excellent ingredient to keep in
                your kitchen cupboard.
              </span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>&nbsp;</span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>
                Not only is it easy to use for roasting, frying, baking, or
                sautéing, but it’s also jam-packed with antioxidants and
                heart-healthy fats.
              </span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>&nbsp;</span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>
                Plus, it’s been studied extensively for its many health
                benefits, with some research suggesting that it could protect
                against heart disease, combat cancer, and alleviate
                inflammation.
              </span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>&nbsp;</span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>
                This article takes a closer look at the potential benefits,
                downsides, and uses of extra virgin olive oil, along with how it
                stacks up against other common cooking oils.
              </span>
            </span>
          </p>
        </div>
        <div className="self-stretch relative tracking-[0.02em] leading-[2rem] text-[1.56rem]">
          <p className="m-0 text-[1.88rem]">
            <b>
              <span>{`What Is Olive Oil & How Is It Made?`}</span>
            </b>
          </p>
          <p className="m-0 text-gainsboro-100">
            <span>
              <b>&nbsp;</b>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>
                <span>
                  Olive oil is a type of oil that has been extracted from
                  olives, the fruits of the olive tree.
                </span>
              </span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>
                <span>&nbsp;</span>
              </span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>
                <span>
                  The production process is simple. Olives can be pressed to
                  extract their oil, but modern methods involve crushing the
                  olives, mixing them, and then separating the oil from the pulp
                  in a centrifuge.
                </span>
              </span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>
                <span>&nbsp;</span>
              </span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>
                <span>
                  After centrifugation, small amounts of oil remain. The
                  leftover oil can be extracted using chemical solvents and is
                  known as olive pomace oil.
                </span>
              </span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>
                <span>&nbsp;</span>
              </span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>
                <span>
                  There are several grades of olive oil, which vary in terms of
                  their nutritional content and the amount of processing that
                  they undergo.
                </span>
              </span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>
                <span>&nbsp;</span>
              </span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>
                <span>The three main grades of olive oil include:</span>
              </span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>
                <span>&nbsp;</span>
              </span>
            </span>
          </p>
          <ul className="m-0 pl-[2.06rem]">
            <li className="mb-[0rem]">
              <span>
                <span>
                  <span>Refined olive oil</span>
                </span>
              </span>
            </li>
            <li className="mb-[0rem]">
              <span>
                <span>
                  <span>Virgin olive oil</span>
                </span>
              </span>
            </li>
            <li className="mb-[0rem]">
              <span>
                <span>
                  <span>Extra virgin olive oil</span>
                </span>
              </span>
            </li>
          </ul>
          <p className="m-0">
            <span>
              <span>
                <span>&nbsp;</span>
              </span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>
                <span>
                  Extra virgin olive oil is the least processed variety and is
                  often considered to be the healthiest type of olive oil. It’s
                  extracted using natural methods and standardized for purity
                  and certain sensory qualities, such as taste and smell.
                </span>
              </span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>
                <span>
                  In addition to its unique flavor and aroma, extra virgin olive
                  oil is rich in disease-fighting antioxidants and has been
                  associated with a wide range of potential health benefits.
                </span>
              </span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>
                <span>&nbsp;</span>
              </span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>
                <span>&nbsp;</span>
              </span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>
                <b>SUMMARY</b>
              </span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>
                <b>&nbsp;</b>
              </span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>
                <span>
                  Modern olive oil is made by crushing olives and separating the
                  oil from the pulp in a centrifuge. Extra virgin olive oil is
                  the least processed variety and is rich in antioxidants.
                </span>
              </span>
            </span>
          </p>
        </div>
        <img
          className="relative w-[96.75rem] h-[54.31rem] object-cover"
          alt=""
          src="/219@2x.png"
        />
        <div className="self-stretch relative tracking-[0.02em] leading-[2rem] text-[1.56rem]">
          <p className="m-0 text-[1.88rem]">
            <b>
              <span>Nutrient Composition of Olive Oil</span>
            </b>
          </p>
          <p className="m-0 text-gainsboro-100">
            <span>
              <b>&nbsp;</b>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>
                Extra virgin olive oil is rich in heart-healthy fats, along with
                vitamins E and K.
              </span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>&nbsp;</span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>
                A tablespoon (about 14 grams) of olive oil contains the
                following nutrients:
              </span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>&nbsp;</span>
            </span>
          </p>
          <ul className="m-0 pl-[2.06rem]">
            <li className="mb-[0rem]">
              <span>
                <span>Calories: 119</span>
              </span>
            </li>
            <li className="mb-[0rem]">
              <span>
                <span>Saturated fat: 14% of total calories</span>
              </span>
            </li>
            <li className="mb-[0rem]">
              <span>
                <span>
                  Monounsaturated fat: 73% of total calories (mostly oleic acid)
                </span>
              </span>
            </li>
            <li className="mb-[0rem]">
              <span>
                <span>Polyunsaturated fat (PUFA): 11% of total calories</span>
              </span>
            </li>
            <li className="mb-[0rem]">
              <span>
                <span>Vitamin E: 13% of the Daily Value (DV)</span>
              </span>
            </li>
            <li className="mb-[0rem]">
              <span>
                <span>Vitamin K: 7% of the DV</span>
              </span>
            </li>
          </ul>
          <p className="m-0">
            <span>
              <span>&nbsp;</span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>
                Extra virgin olive oil is a great source of antioxidants, which
                are compounds that help fight inflammation and chronic disease.
              </span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>&nbsp;</span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>
                The oil’s main antioxidants include the anti-inflammatory
                oleocanthal, as well as oleuropein, a substance that protects
                LDL (bad) cholesterol from oxidation.
              </span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>&nbsp;</span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>
                Some people have criticized olive oil for having a high omega-6
                to omega-3 ratio. However, its total amount of polyunsaturated
                fats is still relatively low, so you probably don’t need to
                worry.
              </span>
            </span>
          </p>
        </div>
        <div className="self-stretch relative tracking-[0.02em] leading-[2rem]">
          <p className="m-0">
            <b>
              <span>What Makes It Healthy?</span>
            </b>
          </p>
          <p className="m-0 text-gainsboro-100">
            <span>
              <b>&nbsp;</b>
            </span>
          </p>
          <p className="m-0 text-[1.56rem]">
            <span>
              <span>
                <span>
                  In addition to its impressive antioxidant content, extra
                  virgin olive oil is loaded with monounsaturated fatty acids, a
                  type of healthy fat that has been linked to several benefits.
                </span>
              </span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>
                <span>&nbsp;</span>
              </span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>
                <span>
                  In particular, research suggests that monounsaturated fatty
                  acids could benefit heart health and may even help protect
                  against heart disease.
                </span>
              </span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>
                <span>&nbsp;</span>
              </span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>
                <span>
                  Extra virgin olive oil also contains a good amount of vitamins
                  E and K in each serving. Vitamin E is an essential nutrient
                  that doubles as an antioxidant, while vitamin K plays a key
                  role in bone health, blood clotting, heart health, and more.
                </span>
              </span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>
                <span>&nbsp;</span>
              </span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>
                <span>&nbsp;</span>
              </span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>
                <b>SUMMARY</b>
              </span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>
                <b>&nbsp;</b>
              </span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>
                <span>
                  Olive oil is very high in monounsaturated fats and contains a
                  modest amount of vitamins E and K. Extra virgin olive oil is
                  also loaded with antioxidants, some of which have powerful
                  health benefits.
                </span>
              </span>
            </span>
          </p>
        </div>
        <div className="self-stretch relative tracking-[0.02em] leading-[2rem]">
          <p className="m-0">
            <b>
              <span>Anti-Inflammatory Substances</span>
            </b>
          </p>
          <p className="m-0 text-gainsboro-100">
            <span>
              <b>&nbsp;</b>
            </span>
          </p>
          <p className="m-0 text-[1.56rem]">
            <span>
              <span>
                <span>
                  Chronic inflammation is believed to be among the leading
                  drivers of many diseases, including heart disease, cancer,
                  metabolic syndrome, type 2 diabetes, and arthritis.
                </span>
              </span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>
                <span>&nbsp;</span>
              </span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>
                <span>
                  Some speculate that olive oil’s ability to fight inflammation
                  is behind many of its health benefits.
                </span>
              </span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>
                <span>&nbsp;</span>
              </span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>
                <span>
                  Oleic acid, the most prominent fatty acid in olive oil, has
                  been shown to reduce inflammatory markers like C-reactive
                  protein (CRP).
                </span>
              </span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>
                <span>&nbsp;</span>
              </span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>
                <span>
                  However, the oil’s main anti-inflammatory effects seem to stem
                  from its content of antioxidants like oleacein and
                  oleocanthal, which appear to significantly reduce inflammation
                  in test-tube and animal studies.
                </span>
              </span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>
                <span>&nbsp;</span>
              </span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>
                <span>
                  Interestingly, several studies have found that regular
                  consumption of olive oil may be linked to lower levels of
                  certain markers of inflammation, including CRP and
                  interleukin-6.
                </span>
              </span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>
                <span>&nbsp;</span>
              </span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>
                <span>
                  However, keep in mind that chronic, low-level inflammation is
                  usually mild, and it takes years or decades for it to do
                  damage. More human studies are needed before we can draw
                  conclusions about olive oil’s ability to counter it.
                </span>
              </span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>
                <span>&nbsp;</span>
              </span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>
                <span>
                  Still, making extra virgin olive oil a regular part of your
                  diet could help protect against damage in the long run,
                  leading to a reduced risk of various inflammatory diseases,
                  including heart disease.
                </span>
              </span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>
                <span>&nbsp;</span>
              </span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>
                <span>&nbsp;</span>
              </span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>
                <b>SUMMARY</b>
              </span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>
                <span>&nbsp;</span>
              </span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>
                <span>
                  Olive oil contains oleic acid and antioxidants, which can help
                  fight inflammation. This may be the main reason for olive
                  oil’s health benefits.
                </span>
              </span>
            </span>
          </p>
        </div>
        <div className="self-stretch relative tracking-[0.02em] leading-[2rem] text-[1.56rem]">
          <p className="m-0 text-[1.88rem]">
            <b>Extra virgin olive oil and heart disease</b>
          </p>
          <p className="m-0 text-gainsboro-100">
            <span>
              <span>&nbsp;</span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>
                Cardiovascular diseases, such as heart disease and stroke, are
                among the most common causes of death in the world.
              </span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>&nbsp;</span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>
                But many observational studies show that death from these
                diseases is low in certain areas of the world, especially in
                Mediterranean countries, where olive oil is a major part of
                people’s diets.
              </span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>&nbsp;</span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>
                This observation spurred interest in the Mediterranean diet,
                which is supposed to mimic the way the people in that region
                eat.
              </span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>&nbsp;</span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>
                Studies on the Mediterranean diet consistently show that it’s
                associated with improved heart health and may help prevent heart
                disease and stroke.
              </span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>&nbsp;</span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>
                Extra virgin olive oil protects against heart disease via
                numerous mechanisms:
              </span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>&nbsp;</span>
            </span>
          </p>
          <ul className="m-0 pl-[2.06rem]">
            <li className="mb-[0rem]">
              <span>
                <span>
                  Reduces inflammation. Olive oil can decrease inflammation, a
                  key driver of heart disease.
                </span>
              </span>
            </li>
          </ul>
          <p className="m-0">
            <span>
              <span>&nbsp;</span>
            </span>
          </p>
          <ul className="m-0 pl-[2.06rem]">
            <li className="mb-[0rem]">
              <span>
                <span>
                  Reduces oxidation of LDL (bad) cholesterol. Olive oil may
                  prevent LDL particles from oxidative damage, an important
                  factor in the development of heart disease.
                </span>
              </span>
            </li>
          </ul>
          <p className="m-0">
            <span>
              <span>&nbsp;</span>
            </span>
          </p>
          <ul className="m-0 pl-[2.06rem]">
            <li className="mb-[0rem]">
              <span>
                <span>
                  Improves blood vessel health. Olive oil may improve the
                  function of the endothelium, which is the lining of the blood
                  vessels.
                </span>
              </span>
            </li>
          </ul>
          <p className="m-0">
            <span>
              <span>&nbsp;</span>
            </span>
          </p>
          <ul className="m-0 pl-[2.06rem]">
            <li className="mb-[0rem]">
              <span>
                <span>
                  Helps manage blood clotting. Some studies suggest that olive
                  oil can help prevent unwanted blood clotting, which could
                  contribute to heart attack and stroke.
                </span>
              </span>
            </li>
          </ul>
          <p className="m-0">
            <span>
              <span>&nbsp;</span>
            </span>
          </p>
          <ul className="m-0 pl-[2.06rem]">
            <li className="mb-[0rem]">
              <span>
                <span>
                  Lowers blood pressure. Research suggests that increased intake
                  of olive oil could be tied to lower blood pressure, which may
                  aid in the prevention of heart disease.
                </span>
              </span>
            </li>
          </ul>
          <p className="m-0">
            <span>
              <span>&nbsp;</span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>
                Given the multitude of health-promoting properties associated
                with olive oil, it’s not surprising that many studies show that
                increased consumption may even be linked to a lower risk of
                heart disease and stroke.
              </span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>&nbsp;</span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>&nbsp;</span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <b>SUMMARY</b>
            </span>
          </p>
          <p className="m-0">
            <span>
              <b>&nbsp;</b>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>
                Olive oil can improve several aspects of heart health. In fact,
                studies show that it may reduce blood pressure and inflammation,
                protect LDL particles from oxidation, improve blood vessel
                health, and help prevent unwanted blood clotting.
              </span>
            </span>
          </p>
        </div>
        <div className="self-stretch relative tracking-[0.02em] leading-[2rem]">
          <p className="m-0">
            <b>
              <span>Other Health Benefits Of Olive Oil</span>
            </b>
          </p>
          <p className="m-0 text-gainsboro-100">
            <span>
              <b>&nbsp;</b>
            </span>
          </p>
          <p className="m-0 text-[1.56rem]">
            <span>
              <span>
                Although olive oil has mostly been studied for its effects on
                heart health, its consumption has been associated with a number
                of other health benefits as well.
              </span>
            </span>
          </p>
        </div>
        <div className="self-stretch relative tracking-[0.02em] leading-[2rem] text-[1.56rem] text-gainsboro-100">
          <p className="m-0 text-[1.88rem] text-white">
            <b>{`Olive Oil & Cancer`}</b>
          </p>
          <p className="m-0">&nbsp;</p>
          <p className="m-0">
            Studies have shown that people living in Mediterranean countries
            have a fairly low risk of cancer, which may be partly due to their
            consumption of anti-inflammatory ingredients, including olive oil.
          </p>
          <p className="m-0">&nbsp;</p>
          <p className="m-0">
            One potential contributor to cancer is oxidative damage due to
            harmful molecules called free radicals. However, extra virgin olive
            oil is high in antioxidants that reduce oxidative damage.
          </p>
          <p className="m-0">&nbsp;</p>
          <p className="m-0">
            Oleic acid, in particular, is also highly resistant to oxidation and
            has been shown to slow the growth and spread of cancer cells in some
            test-tube studies.
          </p>
          <p className="m-0">&nbsp;</p>
          <p className="m-0">
            According to a 2011 review, regular consumption of olive oil may
            also be associated with a lower risk of developing breast cancer or
            cancer of the digestive system.
          </p>
          <p className="m-0">&nbsp;</p>
          <p className="m-0">
            Still, more recent, high quality research is needed to understand
            the effects of olive oil on cancer when enjoyed as part of a
            healthy, well-rounded diet.
          </p>
        </div>
        <div className="self-stretch relative tracking-[0.02em] leading-[2rem]">
          <p className="m-0">
            <b>{`Olive Oil & Alzheimer’s Disease`}</b>
          </p>
          <p className="m-0 text-[1.56rem] text-gainsboro-100">
            <span>
              <span>&nbsp;</span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>
                Alzheimer’s disease is the world’s most common neurodegenerative
                disease and a leading cause of dementia.
              </span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>&nbsp;</span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>
                One feature of Alzheimer’s disease is a buildup of proteins
                known as beta-amyloid plaques in certain neurons in the brain.
              </span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>&nbsp;</span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>
                Animal studies have found that extra virgin olive oil and some
                of the compounds it contains could help preserve brain function
                by preventing the buildup of these proteins.
              </span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>&nbsp;</span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>
                Additionally, some studies show that following the Mediterranean
                diet, which is typically rich in olive oil, may also be
                associated with a reduced the risk of dementia and cognitive
                impairment.
              </span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>&nbsp;</span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>&nbsp;</span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <b>SUMMARY</b>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>&nbsp;</span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>
                Preliminary evidence suggests that olive oil can help fight
                cancer and Alzheimer’s disease, although more human studies need
                to confirm this.
              </span>
            </span>
          </p>
        </div>
        <div className="self-stretch relative tracking-[0.02em] leading-[2rem] text-[1.56rem] text-gainsboro-100">
          <p className="m-0 text-[1.88rem] text-white">
            <b>Eat Up with Abbey Sharp E5: When and How Much</b>
          </p>
          <p className="m-0">&nbsp;</p>
          <p className="m-0">
            How much should you be eating, and how often? Let Registered
            Dietician Abbey Sharp teach you that the answers were inside you all
            along. With the amount of food fear mongering in our culture, it’s
            no wonder most people struggle to nourish themselves properly. This
            series strips nutrition down to its basic facts and provides
            solutions to our most common meal prep stressors.
          </p>
        </div>
        <div className="self-stretch relative tracking-[0.02em] leading-[2rem]">
          <p className="m-0">
            <b>
              <span>Extra Virgin Olive Oil vs. Other Oils</span>
            </b>
          </p>
          <p className="m-0 text-gainsboro-100">
            <span>
              <b>&nbsp;</b>
            </span>
          </p>
          <p className="m-0 text-[1.56rem]">
            <span>
              <span>
                In addition to extra virgin olive oil, there are many other
                popular cooking oils available, including regular olive oil,
                canola oil, vegetable oil, avocado oil, and coconut oil.
              </span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>&nbsp;</span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>
                Here is a closer look at how extra virgin olive oil compares to
                these other types of oils.
              </span>
            </span>
          </p>
        </div>
        <img
          className="relative w-[102.63rem] h-[80.75rem] object-cover"
          alt=""
          src="/220@2x.png"
        />
        <div className="self-stretch relative text-[1.56rem] tracking-[0.02em] leading-[2rem] text-gainsboro-100">
          <p className="m-0">
            <b>SUMMARY</b>
          </p>
          <p className="m-0">
            <b>&nbsp;</b>
          </p>
          <p className="m-0">
            There are several different types of cooking oils available, each of
            which varies in terms of taste, nutritional value, uses, and smoke
            point.
          </p>
        </div>
        <div className="self-stretch relative tracking-[0.02em] leading-[2rem]">
          <p className="m-0">
            <b>
              <span>Can You Cook With It?</span>
            </b>
          </p>
          <p className="m-0 text-gainsboro-100">
            <span>
              <b>&nbsp;</b>
            </span>
          </p>
          <p className="m-0 text-[1.56rem]">
            <span>
              <span>
                <span>
                  During cooking, fatty acids can oxidize, meaning they react
                  with oxygen and become damaged.
                </span>
              </span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>
                <span>&nbsp;</span>
              </span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>
                <span>
                  The double bonds in fatty acid molecules are mostly
                  responsible for this.
                </span>
              </span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>
                <span>&nbsp;</span>
              </span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>
                <span>
                  For this reason, saturated fats — which have no double bonds —
                  are resistant to high heat. Meanwhile, polyunsaturated fats —
                  which have many double bonds — are more sensitive and can
                  become damaged.
                </span>
              </span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>
                <span>&nbsp;</span>
              </span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>
                <span>
                  Olive oil contains mostly monounsaturated fatty acids, which
                  have only one double bond. Therefore, olive oil is fairly
                  resistant to moderate heat.
                </span>
              </span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>
                <span>&nbsp;</span>
              </span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>
                <span>
                  In one 2007 study, researchers heated extra virgin olive oil
                  to 356°F (180°C) for 36 hours and found that the oil was
                  highly resistant to damage.
                </span>
              </span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>
                <span>&nbsp;</span>
              </span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>
                <span>
                  A 2017 review noted that olive oil is comparable or better
                  than other vegetable oils for frying foods at temperatures
                  ranging from 356–374°F (180–190°C).
                </span>
              </span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>
                <span>&nbsp;</span>
              </span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>
                <span>
                  Overall, olive oil seems to be very safe, even for cooking at
                  moderate temperatures.
                </span>
              </span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>
                <span>&nbsp;</span>
              </span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>
                <span>&nbsp;</span>
              </span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>
                <b>SUMMARY</b>
              </span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>
                <b>&nbsp;</b>
              </span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>
                <span>
                  Olive oil is fairly resistant to moderate heat and can be used
                  safely for cooking.
                </span>
              </span>
            </span>
          </p>
        </div>
        <div className="self-stretch relative tracking-[0.02em] leading-[2rem]">
          <p className="m-0">
            <b>
              <span>Risks Of Virgin Olive Olive Oil</span>
            </b>
          </p>
          <p className="m-0 text-gainsboro-100">
            <span>
              <b>&nbsp;</b>
            </span>
          </p>
          <p className="m-0 text-[1.56rem]">
            <span>
              <span>
                <span>
                  Like other types of fat, extra virgin olive oil is high in
                  calories, with around 119 calories in each tablespoon (14 g).
                </span>
              </span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>
                <span>&nbsp;</span>
              </span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>
                <span>
                  Eating more calories than you burn each day contributes to
                  weight gain over time.
                </span>
              </span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>
                <span>&nbsp;</span>
              </span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>
                <span>
                  Therefore, if you’re not making other adjustments to your
                  diet, consuming high amounts of olive oil could make it more
                  challenging to maintain a moderate weight.
                </span>
              </span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>
                <span>&nbsp;</span>
              </span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>
                <span>
                  Additionally, although uncommon, some people may also be
                  allergic to olives and olive oil. If you experience symptoms
                  of an allergic reaction after consuming olive oil, stop using
                  it and speak with a healthcare professional.
                </span>
              </span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>
                <span>&nbsp;</span>
              </span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>
                <span>&nbsp;</span>
              </span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>
                <b>SUMMARY</b>
              </span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>
                <span>&nbsp;</span>
              </span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>
                <span>
                  Olive oil is high in calories and could contribute to weight
                  gain if consumed in high amounts. Some people may also be
                  allergic to olives and olive oil.
                </span>
              </span>
            </span>
          </p>
        </div>
        <div className="self-stretch relative tracking-[0.02em] leading-[2rem]">
          <p className="m-0">
            <b>
              <span>Is It Ok To Cook With Extra Virgin Olive Oil?</span>
            </b>
          </p>
          <p className="m-0 text-gainsboro-100">
            <span>
              <b>&nbsp;</b>
            </span>
          </p>
          <p className="m-0 text-[1.56rem]">
            <span>
              <span>
                Olive oil is made of mostly monounsaturated fats, which are
                resistant to moderate heat.
              </span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>&nbsp;</span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>
                It also has a fairly high smoke point, making it a good choice
                for many cooking methods, including roasting, grilling, baking,
                and sautéing.
              </span>
            </span>
          </p>
        </div>
        <div className="self-stretch relative tracking-[0.02em] leading-[2rem]">
          <p className="m-0">
            <b>
              <span>
                Can You Substitute Extra Virgin Olive Oil For Other Oils in
                Cooking?
              </span>
            </b>
          </p>
          <p className="m-0 text-gainsboro-100">
            <span>
              <b>&nbsp;</b>
            </span>
          </p>
          <p className="m-0 text-[1.56rem]">
            <span>
              <span>
                For most recipes, you can easily swap an equal amount of extra
                virgin olive oil in for other types of oils, including vegetable
                oil, coconut oil, or canola oil.
              </span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>&nbsp;</span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>
                However, keep in mind that extra virgin olive oil often has a
                distinct taste and aroma, so it may slightly alter the flavor of
                your final product.
              </span>
            </span>
          </p>
        </div>
        <div className="self-stretch relative tracking-[0.02em] leading-[2rem]">
          <p className="m-0">
            <b>
              <span>Is Extra Virgin Olive Oil Healthy?</span>
            </b>
          </p>
          <p className="m-0 text-gainsboro-100">
            <span>
              <b>&nbsp;</b>
            </span>
          </p>
          <p className="m-0 text-[1.56rem]">
            <span>
              <span>
                Extra virgin olive oil is loaded with heart-healthy fats and
                antioxidants, making it a great addition to a nutritious diet.
              </span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>&nbsp;</span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>
                It has also been linked to a long list of benefits and may
                protect against inflammation, heart disease, breast cancer, and
                type 2 diabetes.
              </span>
            </span>
          </p>
        </div>
        <div className="self-stretch relative tracking-[0.02em] leading-[2rem]">
          <p className="m-0">
            <b>
              <span>Can Olive Oil Reduce Body Fat</span>
            </b>
          </p>
          <p className="m-0 text-gainsboro-100">
            <span>
              <b>&nbsp;</b>
            </span>
          </p>
          <p className="m-0 text-[1.56rem]">
            <span>
              <span>
                Several studies have found that diets enriched with olive oil
                may be beneficial for weight management and could even help
                reduce body fat.
              </span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>&nbsp;</span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>
                Still, although olive oil may help promote weight control, it’s
                important to keep in mind that oil is high in calories.
              </span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>&nbsp;</span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>
                For this reason, it’s best to swap it in for other fats in your
                diet and keep your intake in moderation to maximize the
                potential benefits.
              </span>
            </span>
          </p>
        </div>
        <div className="self-stretch relative tracking-[0.02em] leading-[2rem]">
          <p className="m-0">
            <b>
              <span>Can I Use Extra Virgin Olive Oil On My Face?</span>
            </b>
          </p>
          <p className="m-0 text-gainsboro-100">
            <span>
              <b>&nbsp;</b>
            </span>
          </p>
          <p className="m-0 text-[1.56rem]">
            <span>
              <span>
                Olive oil is often used as a natural skincare product. It can be
                applied directly to the face, either alone or combined with
                other ingredients like honey or egg yolks.
              </span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>&nbsp;</span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>
                In addition to moisturizing your skin, some research suggests
                that olive oil could reduce inflammation, promote wound healing,
                and slow skin aging.
              </span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>&nbsp;</span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>
                However, be sure to wipe off any excess oil to prevent blocked
                pores, and always do a patch test before applying anything
                directly to your face.
              </span>
            </span>
          </p>
        </div>
        <div className="self-stretch relative tracking-[0.02em] leading-[2rem]">
          <p className="m-0">
            <b>
              <span>The Bottom Line</span>
            </b>
          </p>
          <p className="m-0 text-gainsboro-100">
            <span>
              <b>&nbsp;</b>
            </span>
          </p>
          <p className="m-0 text-[1.56rem]">
            <span>
              <span>
                <span>
                  Not only is extra virgin olive oil loaded with heart-healthy
                  fats, but it’s also a great source of antioxidant compounds,
                  like vitamin E, oleacein, and oleocanthal.
                </span>
              </span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>
                <span>&nbsp;</span>
              </span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>
                <span>
                  It has been associated with a wide range of powerful health
                  benefits and may help prevent heart disease, promote brain
                  function, and protect against certain types of cancer.
                </span>
              </span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>
                <span>&nbsp;</span>
              </span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>
                <span>
                  Plus, it’s incredibly versatile and makes a great addition to
                  a variety of recipes, ranging from baked goods to stir-fries,
                  sautéed veggies, salad dressings, and more.
                </span>
              </span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>
                <i>&nbsp;</i>
              </span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>
                <i>Try this today:</i>
                <span>
                  {" "}
                  One of the easiest ways to boost your intake of extra virgin
                  olive oil is by drizzling it overcooked dishes. Try using it
                  to dial up the flavor and health benefits of roasted veggies,
                  cooked meats, pasta dishes, and more.
                </span>
              </span>
            </span>
          </p>
        </div>
        <a className="cursor-pointer text-darkgray no-underline" href={"/lesson37"}>
        <div className="rounded-32xl bg-gainsboro-200 box-border w-[25rem] flex flex-col items-center justify-center pt-[0.69rem] px-[3rem] pb-[1rem] max-w-[31.25rem] text-center text-[1.88rem] border-[1px] border-solid border-gray-300">
          <b className="self-stretch relative">Next Chapter</b>
        </div>
      </a>
      </div>
    </div>
  );
};

export default Lesson36;
